import { useState } from 'react';

/**
 *  활성화 및 비활성화에 필요한 함수와 state를 반환하는 커스텀 훅
 * @param {boolean} startStatus 시작 상태 (defalult: false)
 * @returns [status: boolean, switching function]
 *  */
function useSwitching(startStatus: boolean = false): [boolean, (param?: boolean) => void] {
  const [active, setActive] = useState<boolean>(startStatus);
  const switching = (param?: boolean): void => {
    setActive(param === undefined ? (prev: boolean) => !prev : param);
  };

  return [active, switching];
}

export default useSwitching;
